import React, { useEffect, useState } from 'react';
import API from '../Api';
import SubPageHeader from '../../components/common/SubPageHeader';
import newsThumbnail from '../../assets/images/NewsImg.png'; // The screenshot of the HT article

const News = () => {
  const [newsList, setNewsList] = useState([]);

  const resolveImageUrl = (imgData) => {
    if (!imgData) return newsThumbnail;
    if (typeof imgData === 'string' && imgData.startsWith('http')) return imgData;
    return imgData.startsWith('/') 
      ? `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${imgData}` 
      : `${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/${imgData}`;
  };

  useEffect(() => {
    const fetchNews = async () => {
      
      const defaultNews = [{
        title: "Pune's father-daughter duo takes a deep dive...",
        desc: "It was when Owee was in Class 7 that she was inspired by a show on Discovery Channel...",
        url: "https://www.hindustantimes.com/pune-news/father-daughter-duo-takes-a-deep-dive-into-their-passion-for-underwater-exploration/story-k2fS8km8uiyxZQjjRVEkII.html?utm_source=ht_site_copyURL&utm_medium=social&utm_campaign=ht_site",
        img: newsThumbnail,
        source: "Hindustan Times"
      }];

      try {
        const res = await API.get('get-content/NewsList/');
        const data = res.data;
        
       
        const tempNewsList = [...defaultNews];
        
       
        let i = 2; 
        while (i <= 10) {
          if (data[`news${i}_title`]) {
            tempNewsList.push({
              title: data[`news${i}_title`],
              desc: data[`news${i}_desc`],
              url: data[`news${i}_url`],
              img: data[`news${i}_img`],
              source: data[`news${i}_source`] || "Media"
            });
          }
          i++;
        }
        
        setNewsList(tempNewsList);
      } catch (err) {
        console.error("Error loading news:", err);
        setNewsList(defaultNews);
      }
    };
    fetchNews();
  }, []);
  return (
    <div className="min-h-screen bg-white">
      <SubPageHeader title="News" />

      <div className="py-20 px-4">
        <div className="max-w-5xl mx-auto space-y-20">
          
          {newsList.map((news, index) => (
            <div key={index} className="relative z-10 text-center space-y-8 pb-16 border-b border-gray-200">
              
              <h2 className="text-2xl md:text-3xl font-bold text-[#032167] px-4">{news.title}</h2>
              <div className="w-16 h-[2px] bg-gray-400 mx-auto"></div>
              
              <p className="text-lg text-gray-800 max-w-3xl mx-auto leading-relaxed">{news.desc}</p>

              {/* News Image */}
              <div className="max-w-md mx-auto bg-white p-2 shadow-2xl border border-gray-200">
                <img 
                  src={news.img ? (news.img.startsWith('http') ? news.img : `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${news.img}`) : newsThumbnail} 
                  alt="News" 
                  className="w-full h-auto"
                  onError={(e) => { e.target.src = newsThumbnail; }} 
                />
              </div>

              <div className="space-y-6">
                <h3 className="text-2xl font-serif text-[#032167]">By {news.source || "Media"}</h3>
                
                <div className="pt-4">
                  <a 
                    href={news.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block border border-gray-400 px-8 py-2 text-sm text-gray-600 uppercase tracking-[2px] hover:bg-[#032167] hover:text-white hover:border-[#032167] transition-all duration-300"
                  >
                    Read More >
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default News;